<template>
  <section id="intro" class="page flex">

    <navigation-top/>

    <section class="hero2">
      <section>
        <svg xmlns="http://www.w3.org/2000/svg" v-on:click="letterDesign(), letterDevelop()" class="brain" width="120" viewBox="0 0 120 120"><defs><linearGradient id="deg0" osb:paint="gradient"><stop offset="0" stop-color="#262c43"/><stop offset="1" stop-color="#3d4765"/></linearGradient><linearGradient xlink:href="#deg0" id="degra" x1="10" y1="80" x2="80" y2="20" gradientUnits="userSpaceOnUse"/></defs><path d="M48.697 41.219c-4.232.118-8.339 3.141-9.639 8.34-.131.525-.218 1.024-.283 1.51-1.035-.69-2.132-1.13-3.234-1.326-2.257-.401-4.461.172-6.221 1.289-1.76 1.117-3.125 2.786-3.666 4.76-.198.721-.264 1.487-.195 2.258-.509-.091-1.015-.126-1.51-.107-1.026.039-2.006.305-2.877.764-1.742.917-3.07 2.489-4.02 4.324-1.898 3.671-2.402 8.517-.662 12.494.114.272.307.505.553.668-.267.304-.52.618-.74.953-1.406 2.139-1.948 4.801-1.631 7.338.317 2.536 1.551 5.02 3.865 6.475.386.243.807.44 1.244.615-1.081 1.356-1.569 3.075-1.477 4.789.151 2.8 1.478 5.707 3.357 8.313 1.879 2.606 4.331 4.906 7.004 6.285 2.637 1.36 5.685 1.81 8.25.295l.201.271c1.166 1.432 2.928 2.14 4.828 2.424 1.9.284 4.005.155 6.129-.268 3.681-.732 7.422-2.313 10.039-4.645 2.617 2.331 6.358 3.912 10.039 4.645 2.124.422 4.229.551 6.129.268 1.9-.284 3.662-.992 4.828-2.424l.201-.271c2.565 1.516 5.613 1.066 8.25-.295 2.673-1.379 5.125-3.679 7.004-6.285 1.879-2.606 3.207-5.512 3.357-8.313.092-1.716-.398-3.435-1.48-4.791.426-.172.837-.365 1.215-.602 2.306-1.446 3.532-3.922 3.846-6.449.314-2.528-.229-5.183-1.623-7.322-.222-.341-.478-.661-.748-.971.272-.164.484-.41.607-.703 1.725-3.943 1.307-8.631-.563-12.215-.935-1.792-2.259-3.33-3.98-4.271-.861-.471-1.825-.774-2.844-.877-.552-.056-1.12-.048-1.697.02.089-.815.027-1.627-.182-2.389-.541-1.974-1.905-3.643-3.664-4.76-1.76-1.117-3.964-1.69-6.221-1.289-1.102.196-2.199.636-3.234 1.326-.066-.486-.154-.985-.285-1.51-1.485-5.941-6.639-9.043-11.453-8.211-3.06.529-5.863 2.645-7.502 6.166-1.639-3.521-4.442-5.637-7.502-6.166-.602-.104-1.21-.146-1.814-.129z" fill="url(#degra)"/><g stroke="#1f2435" stroke-width="3" stroke-linecap="round" fill="none"><path d="M58.014 54.922c0-15-14.853-15.589-17.5-5-2.5 10 8.75 8 8.75 16"/><path d="M40.514 54.922c-6.125-9-17.5 0-12.25 6"/><path d="M17.764 74.922c-3.009-6.878 1.75-18 8.75-15 4.777 2.047 9.5 9 4.5 14"/><path d="M58.014 106.922c-4.465 5.103-16.476 7.781-19.833 3.657-3.792-4.657 1.458-12.657 5.833-5.657"/><path d="M23.014 74.922c-10 0-10 20 4.375 15"/><path d="M36.139 109.922c-8.125 5-23.125-15-13.125-19"/><path d="M58.014 54.922c0-15 14.853-15.589 17.5-5 2.5 10-8.75 8-8.75 16"/><path d="M75.514 54.922c6.125-9 17.5 0 12.25 6"/><path d="M98.264 74.922c3.009-6.878-1.471-17.24-8.75-15-6.5 2-.5 11-12.5 10"/><path d="M58.014 106.922c4.465 5.103 16.476 7.781 19.833 3.657 3.792-4.657-1.458-12.657-5.833-5.657"/><path d="M88.014 76.922c2-2 4-2.012 5-2 9.903.117 9.953 19.984-4.375 15"/><path d="M79.889 109.922c8.125 5 23.125-15 13.125-19"/></g><g stroke-width="3" stroke-linecap="round" fill="none"><path class="NleftTop" d="M57 75c-17.5-12-22 5-13 5" stroke="#4fdfad"/><path class="NleftBot" d="M57.9 99.922c-.819-4.679-3.697-10.9-12.945-7.782-14.18 4.782-11.555-6.218-8.93-7.218" stroke="#ffe680"/><path class="NrightTop" d="M58.3 84.922c11 5 17-4 10-10" stroke="#e95095"/><path class="NrightBot1" d="M83.4 94.922c-15-10-10 10-25 5" stroke="#4fdfad"/><path class="NrightBot2" d="M78 91.922l5-10" stroke="#4fdfad"/></g><g stroke-width="2" stroke-linecap="round" fill="none"><path class="star" d="M12.566 24.499c1-1 2.943 1.909 3.328 1.924.384.015 3.17-1.888 3.472-1.65.302.238-.906 3.389-.802 3.759.104.37 2.776 2.431 2.642 2.792-.133.36-3.503.186-3.823.399-.32.213-1.455 3.391-1.839 3.376-.384-.015-1.259-3.274-1.561-3.513-.302-.238-3.675-.336-3.779-.706-.104-.37 2.725-2.209 2.858-2.57.133-.36-.816-3.599-.497-3.812z" stroke="#e95095"/><path class="love" d="M103.566 20.499c-2 1-2.373 3.824-1.246 5.568 1.007 1.559-.162 4.749-.004 4.867.158.117 2.872-1.927 4.657-1.414 1.996.573 4.345-.022 4.968-2.807.623-2.784-1.8-4.573-4.576-2.584 1.005-3.063-1.514-4.867-3.799-3.63z" stroke="#e95095"/><g class="asterix" stroke="#4fdfad"><path d="M46.604 19.593l12.223 3.03"/><path d="M54.231 14.997l-3.03 12.223"/><path d="M48.902 23.406l7.626-4.596"/><path d="M50.418 17.295l4.596 7.626"/></g><path class="triangle" d="M72.566 26.499c1-1 9 1 9.8 2.634.263.983-6.213 7.459-7.196 7.196-.983-.263-3.354-9.11-2.634-9.83z" stroke="#ffe680"/></g><g fill="#1f2435"><circle class="point point-1" cx="70.566" cy="7.499" r="1.6"/><circle class="point point-2" cx="31.566" cy="9.499" r="1.6"/><circle class="point point-3" cx="35.566" cy="35.499" r="1.6"/><circle class="point point-4" cx="8.566" cy="47.499" r="1.6"/><circle class="point point-5" cx="93.566" cy="42.499" r="1.6"/><circle class="point point-6" cx="86.566" cy="18.499" r="1.6"/></g><path d="M58.014 54.922v52" stroke="#1f2435" stroke-width="3" stroke-linecap="round" fill="none"/></svg>
      </section>
      <section>
        <hgroup itemscope="itemscope" itemptype="http://schema.org/Person">
          <h1 itemprop="name">KÉVIN LE SAOUT</h1>
          <h2 itemprop="jobTitle"><i class="h2_web" v-on:click="letterDesign()">DESIGN</i> <span class="h2_slash" v-on:click="easterEgg()">&</span> <i class="h2_dev" v-on:click="letterDevelop()">DEVELOPPEMENT WEB</i></h2>
          <router-link to="about">En savoir plus ..</router-link>
          <small class="easter" v-if="egg"><i>Achievement Get !</i> <em>Easter Egg</em></small>
        </hgroup>
      </section>
    </section>

  </section>
</template>

<script>
import {meta} from '../meta'
import NavigationTop from '@/components/Template_Navigation_Top'

export default {
  name: 'intro',
  components: {
    'navigation-top': NavigationTop
  },
  data () {
    return {
      egg: false
    }
  },
  beforeCreate () {
    var metaTitle = 'Kévin Le Saout - Webdesign / Développeur JS'
    var metaDesc = 'Portfolio du webdesigner Kévin Le Saout, développeur front-end et UI/UX designer. Conception de site web vitrine et ecommerce, création de logos, charte graphique, illustrations sur devis. Référencement et campagne adwords, hébergement et maintenance de serveur. Formation gestionnaire Wordpress.'
    meta(metaTitle, metaDesc)
  },
  mounted () {
    // brain :hover class
    var brain = document.querySelector('.brain')
    brain.addEventListener('mouseover', function () {
      if (!brain.classList.contains('excited')) {
        brain.classList.add('excited')
      }
    }, false)
    brain.addEventListener('mouseleave', function () {
      if (brain.classList.contains('excited')) {
        setTimeout(function () { brain.classList.remove('excited') }, 1000)
      }
    }, false)
  },
  created () {
    window.addEventListener('wheel', this.handleScroll)
    window.addEventListener('touchmove', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('wheel', this.handleScroll)
    window.removeEventListener('touchmove', this.handleScroll)
  },
  methods: {
    handleScroll (event) {
      var ico = document.querySelector('.ico')
      if (!ico.classList.contains('here')) {
        ico.classList.add('here')
        setTimeout(function () { ico.classList.remove('here') }, 500)
      }
    },

    letterDesign () {
      var name = document.querySelector('.hero2 h1')
      setTimeout(function () { name.style.color = '#4fdfad' }, 50)
      setTimeout(function () { name.style.color = '#e95095' }, 500)
      setTimeout(function () { name.style.color = '#f5d678' }, 1000)
      setTimeout(function () { name.style.color = '#fff' }, 1500)
    },

    letterDevelop () {
      var name = document.querySelector('.hero2 h1')
      setTimeout(function () { name.innerHTML = 'Xé\\/:N ℓe 5a*µY' }, 50)
      setTimeout(function () { name.innerHTML = 'KÉVIN LE SAOUT' }, 500)
      setTimeout(function () { name.innerHTML = '\\<€v1n l€ $^0u†' }, 1000)
      setTimeout(function () { name.innerHTML = 'KÉVIN LE SAOUT' }, 1500)
    },

    easterEgg () {
      var name = document.querySelector('.hero2 h1')
      setTimeout(function () { name.style.color = '#4fdfad' }, 200)
      setTimeout(function () { name.style.color = '#e95095' }, 400)
      setTimeout(function () { name.style.color = '#f5d678' }, 600)
      setTimeout(function () { name.style.color = '#ffffff' }, 800)
      setTimeout(function () { name.style.color = '#4fdfad' }, 1000)
      setTimeout(function () { name.style.color = '#e95095' }, 1200)
      setTimeout(function () { name.style.color = '#f5d678' }, 1400)
      setTimeout(function () { name.style.color = '#ffffff' }, 1600)
      setTimeout(function () { name.style.color = '#4fdfad' }, 1800)
      setTimeout(function () { name.style.color = '#e95095' }, 2000)
      setTimeout(function () { name.style.color = '#f5d678' }, 2200)
      setTimeout(function () { name.style.color = '#4fdfad' }, 2400)
      setTimeout(function () { name.style.color = '#e95095' }, 2600)
      setTimeout(function () { name.style.color = '#ffffff' }, 2800)
      setTimeout(function () { name.innerHTML = 'XÉVIN LE SAOUT' }, 200)
      setTimeout(function () { name.innerHTML = 'KΣVIN LE SAOUT' }, 400)
      setTimeout(function () { name.innerHTML = 'KÉ√IN LE SAOUT' }, 600)
      setTimeout(function () { name.innerHTML = 'KÉV:N LE SAOUT' }, 800)
      setTimeout(function () { name.innerHTML = 'KÉVI𝒩 E SAOUT' }, 1000)
      setTimeout(function () { name.innerHTML = 'KÉVIN ℓE SAOUT' }, 1200)
      setTimeout(function () { name.innerHTML = 'KÉVIN L€ SAOUT' }, 1400)
      setTimeout(function () { name.innerHTML = 'KÉVIN LE $AOUT' }, 1600)
      setTimeout(function () { name.innerHTML = 'KÉVIN LE S^OUT' }, 1800)
      setTimeout(function () { name.innerHTML = 'KÉVIN LE SA0UT' }, 2000)
      setTimeout(function () { name.innerHTML = 'KÉVIN LE SAOµT' }, 2200)
      setTimeout(function () { name.innerHTML = 'KÉVIN LE SAOU†' }, 2400)
      setTimeout(function () { name.innerHTML = 'KÉVIN LE SAOUT' }, 2600)
      setTimeout(function () { name.innerHTML = 'XΣ√:𝒩 ℓ€ $^0µ†' }, 2800)
      this.egg = true
      setTimeout(() => { this.egg = false }, 5000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page_Intro.vue